import { Injectable } from '@angular/core';
import { EMPTY, Observable, Subject } from 'rxjs';
import { UID } from '@farris/devkit';
import { GspFramework } from './types';
/**
 * @Author: aalizzwell
 * @Date: 2019-07-23 15:56:11
 * @Last Modified by: aalizzwell
 * @Last Modified time: 2019-11-27 15:31:36
 */


/**
 * RuntimeFrameworkService
 * @scope @FormModule
 */
// tslint:disable: no-string-literal disable: max-line-length
@Injectable()
export class RuntimeFrameworkService {
    private rtfService: any;
    private _gspFrameworkService: GspFramework.FrameworkService = null;
    constructor() {
      this.rtfService = this.getRuntimeFrameworkService();
    }
    /**
     * è·årtfæå¡
     */
    private getRuntimeFrameworkService() {
      const frameworkService = this.gspFrameworkService;
      return frameworkService && frameworkService.rtf || {};
    }
    private get gspFrameworkService() {
      if (this._gspFrameworkService) {
        return this._gspFrameworkService;
      }
      let env: Window = window;
      try {
        while (env.location.origin === env.parent.location.origin && env !== env.parent && !(env as any).isRTFTopWin) {
          env = env.parent;
        }
      } catch (e) {
        console.error(e);
      }

      this._gspFrameworkService = env['gspframeworkService'];
      return this._gspFrameworkService;
    }
    public get common(): GspFramework.CommonService {
      return this.gspFrameworkService && this.gspFrameworkService.common;
    }
    // #region commonæå¡
    public get userInfo(): GspFramework.UserInfo {
      return this.common && this.common.userInfos && this.common.userInfos.get() || null;
    }
    // #endregion
    // #region å¯¼èªæå¡
    /**
     * æå¼èåæåºç¨
     * @param options - options
     */
    openMenu(options: any) {
      if (this.rtfService && this.rtfService.hasOwnProperty('func') && typeof this.rtfService['func']['openMenu'] === 'function') {
        this.rtfService.func.openMenu(options);
      }
    }
    /**
     * æå¼èåæåºç¨
     * @param options - options
     */
    openMenu$(options: any) {
      if (this.rtfService && this.rtfService.hasOwnProperty('func') && typeof this.rtfService['func']['openMenuByStream'] === 'function') {
        return this.rtfService.func.openMenuByStream(options);
      }
      return EMPTY;
    }
    /**
     * è·åå¯¼èªå®ä½æ°æ®
     * @param tabId - tabid
     * @param callback - callback
     * @param once - once
     */
    getEntityParam(tabId: string, callback: any, once: boolean = true) {
      if (this.rtfService && this.rtfService.hasOwnProperty('func') && typeof this.rtfService['func']['getEntityParam'] === 'function') {
        this.rtfService.func.getEntityParam(tabId, callback, once);
      }
    }
    /**
     * å°è¯å³é­èåæåºç¨
     * @param options - optins
     */
    beforeCloseMenu(options: any) {
      if (this.rtfService && this.rtfService.hasOwnProperty('func') && typeof this.rtfService['func']['beforeClose'] === 'function') {
        this.rtfService.func.beforeClose(options);
      }
    }
    /**
     * å³é­èå
     * @param options - options
     */
    closeMenu(options: any) {
      if (this.rtfService && this.rtfService.hasOwnProperty('func') && typeof this.rtfService['func']['close'] === 'function') {
        this.rtfService.func.close(options);
      }
    }
    /**
     * è·åèåéæåæ°
     * @param funcId - èåid
     * @param callback - åè°
     */
    getMenuParams(funcId: string, callback: (params) => void) {
      if (this.rtfService && this.rtfService.hasOwnProperty('func') && typeof this.rtfService['func']['getMenuParams'] === 'function') {
        this.rtfService.func.getMenuParams(funcId, callback);
      }
    }
    /**
     * æ·»å äºä»¶çå¬
     * @param token
     * @param handler
     * @param options
     */
    addEventListener(token: string, handler: (value: any) => void, options: any) {
      if (this.rtfService && this.rtfService.hasOwnProperty('frmEvent') && typeof this.rtfService['frmEvent']['eventListener'] === 'function') {
        this.rtfService.frmEvent.eventListener(token, handler, options);
      }
    }
    /**
     * è·åè¿è¡æ¡æ¶èååæ¢æ§å¶äºä»¶
     * @returns Observable<any>
     */
    public getMenuSwitchControlEvent(): Observable<any> {
      const subject = new Subject<any>();
      const frmEvent = this.rtfService && this.rtfService.frmEvent || null;
      if (frmEvent) {
        const tabId = this.tabId;
        const options = this.params;
        window.setTimeout(() => {
          frmEvent.eventListener(tabId, (response: { menuSwitchControl: { key: any, value: any; }, [prop: string]: any; }) => {
            const menuSwitchControl = response && response.menuSwitchControl || null;
            if (menuSwitchControl && menuSwitchControl.key === tabId) {
              subject.next(menuSwitchControl.value);
            } else {
              subject.next(null);
            }
          }, options);
        }, 0);
      }
      return subject;
    }
    // #endregion

    // #region ééå±å±æ§
    public get params() {
      if (this.rtfService && this.rtfService.hasOwnProperty('session') && typeof this.rtfService['session']['getCommonVariable'] === 'function') {
        return this.rtfService['session']['getCommonVariable']();
      }
      return null;
    }
    /**
     * è·åtabId
     */
    public get tabId() {
      return this.params && this.params['tabId'] || null;
    }
    /**
     * è·åformToken
     */
    public get formToken() {
      return this.params && this.params['formToken'] || null;
    }
    /**
     * è·åfuncId
     */
    public get funcId() {
      return this.params && this.params['funcId'] || null;
    }
    // #endregion

    // #region äºä»¶éä¿¡
    /**
     * æ³¨åä¸»é¢
     * @param code - ä¸»é¢çæ è¯
     * @param options - tokençæè§å
     * @param subject - èªå®ä¹ä¸»é¢ï¼é»è®¤ä½¿ç¨Subject
     * @returns string æ³¨åæååè¿åä¸»é¢çå¯ä¸æ è¯
     */
    public subjectRegister(code: string, options: any, subject?: Subject<any>): string {
      if (this.rtfService && this.rtfService.hasOwnProperty('broadcast') && typeof this.rtfService['broadcast']['subjectRegister'] === 'function') {
        return this.rtfService.broadcast.subjectRegister(code, options, subject);
      }
      return null;
    }
    /**
     * ç§»é¤ä¸»é¢
     * @param token - ä¸»é¢å¯ä¸æ è¯
     */
    public subjectRemove(token: string) {
      if (this.rtfService && this.rtfService.hasOwnProperty('broadcast') && typeof this.rtfService['broadcast']['subjectRemove'] === 'function') {
        this.rtfService.broadcast.subjectRemove(token);
      }
    }
    /**
     * ç»ä¸»é¢åéæ¶æ¯
     * @param token - ä¸»é¢æ è¯
     * @param info - æ¶æ¯
     */
    public subjectNotify(token: string, info: any) {
      if (this.rtfService && this.rtfService.hasOwnProperty('broadcast') && typeof this.rtfService['broadcast']['notify'] === 'function') {
        this.rtfService.broadcast.notify(token, info);
      }
    }
    /**
     * æ³¨åä¸»é¢çå¬å¨
     * @param token - ä¸»é¢æ è¯
     * @param handler - ä¸»é¢å¤çå¨
     * @param observerToken - çå¬å¨id(å¯é)
     * @returns çå¬å¨Id
     * @description çå¬ä¸»é¢æ¶æ¯ï¼çå¬æåè¿åå½åçå¬èçå¯ä¸æ è¯
     */
    public subjectResponse(token: string, handler: (data: any) => void, observerToken?: string): string {
      if (this.rtfService && this.rtfService.hasOwnProperty('broadcast') && typeof this.rtfService['broadcast']['response'] === 'function') {
        let code = observerToken;
        if (typeof observerToken === 'undefined' || !observerToken || observerToken.length < 1) {
          code = UID.create();
        }
        this.rtfService.broadcast.response(token, code, handler);
        return code;
      }
      return null;
    }
    /**
     * åæ¶å¯¹ä¸»é¢ççå¬
     * @param token - ä¸»é¢æ è¯
     * @param observerToken - çå¬å¨æ è¯
     */
    public responseUnSubscribe(token: string, observerToken: string) {
      if (this.rtfService && this.rtfService.hasOwnProperty('broadcast') && typeof this.rtfService['broadcast']['responseUnSubscribe'] === 'function') {
        this.rtfService.broadcast.responseUnSubscribe(token, observerToken);
      }
    }
    // #endregion

    // #region å·¥å·å½æ°
    /**
     * æ¯å¦åæº
     * @param environment - window
     */
    private isSameOrigin(environment: Window) {
      const host = window.location.host;
      try {
        if (environment && environment.location && typeof environment.location.host !== 'undefined') {
          return environment.location.host === host;
        }
      } catch (e) {
        return false;
      }

      return false;
    }
    // #endregion
}
